import React from 'react';
import $ from 'jQuery';

module.exports = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired,
    className: React.PropTypes.string
  },
  trim(raw) {
    if(!raw) return 'Untitled';
    var div = $('<div/>');

      var temp = div.html(raw.replace(/#\\/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/alert\(.*\)/g, '').replace(/src\=.*\s/g, '').replace('&nbsp;',' '));
      temp.find('audio').replaceWith('<span class="text-italic">[audio]</span>');
      temp.find('img').replaceWith('<span class="text-italic">[image]</span>');
      temp.find('video').replaceWith('<span class="text-italic">[video]</span>');
      temp.find('a').replaceWith('<span class="text-italic">[link]</span>');
      temp.find('table').replaceWith('<span class="text-italic">[table]</span>');
      temp.find('script').replaceWith('');
      temp.find('br').replaceWith('');
      var text = temp.text().replace(/(\r\n|\n|\r)/gm, '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      if (text == "")
          return '<span class="text-italic">' +'<Untitled>' + '</span>';

      text = jQuery('<p>' + temp.text() + '</p>').text();
      return text.length > 200 ?  text.slice(0,200) + '...' : text;
  },
  render() {
    return <span className={this.props.className}>
      {this.trim(this.props.text)}
    </span>
  }
});



/** WEBPACK FOOTER **
 ** ./src/trim/index.js
 **/